export default "__VITE_ASSET__qfjLO28K__"